module.exports = __webpack_public_path__ + "static/media/dislike_active.7f7e2d8e.svg";